import React from 'react';
import avatar from './../../assets/img/default-avatar.png';

export default class CardPersonal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            src: this.props.identificacion? "https://talentohumano.espol.edu.ec/imgEmpleado/" + this.props.identificacion.trim() + ".jpg" : avatar,
            errored: false,
        };

        this.onError = this.onError.bind(this);
    }

    onError = () => {
        if (!this.state.errored) {
            this.setState({
                src: avatar,
                errored: true,
            });
        }
    }

    render() {

        return (
            <div id={this.props.identificacion}>
                <div align="center" className="pt-3">
                    <img align="center" width="45%" height="45%" src={this.state.src} onError={this.onError} />
                </div>
                <div align="center" className="pt-2">{this.props.nombres} {this.props.apellidos}</div>

                <div align="center">{this.props.identificacion}</div>            
            </div>
        );
    }
}